export enum BlockingStatus
{
    Blocked = 1,
    Unblocked = 2,
    None = 0
}